import { X } from 'lucide-react';

interface SelectedAdvisorBarProps {
  advisor: {
    advisorId: string;
    advisorFirstName: string | null;
    advisorLastName: string | null;
    advisorEmail: string;
    organizationDisplayName?: string | null;
    organizationName?: string | null;
  };
  onChangeAdvisor: () => void;
}

export function SelectedAdvisorBar({ advisor, onChangeAdvisor }: SelectedAdvisorBarProps) {
  const fullName =
    `${advisor.advisorFirstName || ''} ${advisor.advisorLastName || ''}`.trim() || 'Unknown';

  return (
    <div className="flex items-center gap-3">
      <span className="text-xs text-orange-800">Viewing as</span>
      <div className="flex items-center gap-1.5 rounded-full border border-orange-300 bg-white py-1 pl-3 pr-1.5">
        <span className="text-xs font-medium text-gray-900">{fullName}</span>
        <span className="text-xs text-gray-700">{advisor.advisorEmail}</span>
        <button
          onClick={onChangeAdvisor}
          className="ml-1 flex h-5 w-5 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-orange-100 hover:text-orange-600"
          aria-label="Change advisor"
        >
          <X className="h-3 w-3" />
        </button>
      </div>
    </div>
  );
}
